// Alert
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

//  NAME:Settings
export const REQUESTING_SKELETON = "REQUESTING_SKELETON";
export const GET_SKELETON = "GET_SKELETON";
export const SKELETON_ERROR = "SKELETON_ERROR";

//  NAME Error
export const SET_ERROR = "SET_ERROR";

//  NAME: Modals
export const SET_CONFIRM_MESSAGE = "SET_CONFIRM_MESSAGE";
export const REMOVE_CONFIRM_MESSAGE = "REMOVE_CONFIRM_MESSAGE";
export const SET_IS_CONFIRM = "SET_IS_CONFIRM";
export const SET_CONFIRM_FIELD = "SET_CONFIRM_FIELD";
export const REMOVE_CONFIRM_FIELD = "REMOVE_CONFIRM_FIELD";

// Permissions
export const GET_PERMISSIONS = "GET_PERMISSIONS";
export const GET_PERMISSION = "GET_PERMISSION";
export const SET_PERMISSIONS = "SET_PERMISSIONS";
export const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS";
export const SET_USER_ROLE = "SET_USER_ROLE";
export const SET_PERMISSION = "SET_PERMISSION";
export const CHECK_PERMISSIONS = "CHECK_PERMISSIONS";
export const CHECK_PERMIISSION = "CHECK_PERMISSION";
export const PERMISSION_ERROR = "PERMISSION_ERROR";
export const LOADING_USER_PERMISSION = "LOADING_USER_PERMISSION";
export const LOADING_COMPONENT_PERMISSION = "LOADING_COMPONENT_PERMISSION";

// Misc
export const SET_APP_ENV = "SET_APP_ENV";
export const SET_APP_CODE = "SET_APP_CODE";
export const SET_APP_ROUTE = "SET_APP_ROUTE";
export const UPDATE_SEARCH_COLUMN = "UPDATE_SEARCH_COLUMN";
export const UPDATE_SEARCH_COLUMN_FAILED = "UPDATE_SEARCH_COLUMN_FAILED";
export const CLEAR_ALL_SEARCH_FIELDS = "CLEAR_ALL_SEARCH_FIELDS";
export const GET_GROUP_LIST = "GET_GROUP_LIST";
export const REMOVE_GROUP_LIST = "REMOVE_GROUP_LIST";
export const GET_MISC_CONTRACT = "GET_MISC_CONTRACT";
export const REMOVE_MISC_CONTRACT = "REMOVE_MISC_CONTRACT";

// Datable
export const SET_DATATABLE = "SET_DATATABLE";
export const REMOVE_DATATABLE = "REMOVE_DATATABLE";
export const UPDATE_DATATABLE_SEARCH = "UPDATE_DATATABLE_SEARCH";
export const REMOVE_DATATABLE_SEARCH = "REMOVE_DATATABLE_SEARCH";
export const SET_DATATABLE_LOADING = "SET_DATATABLE_LOADING";
export const REMOVE_DATATABLE_LOADING = "REMOVE_DATATABLE_LOADING";
export const UPDATE_DATATABLE_ORDER = "UPDATE_DATATABLE_ORDER";
export const DATATABLE_DOWNLOADING = "DATATABLE_DOWNLOADING";
export const DATATABLE_UPDATING = "DATATABLE_UPDATING";
export const SET_DATATABLE_CONFIRM_STATE = "SET_DATATABLE_CONFIRM_STATE";
export const REMOVE_DATATABLE_CONFIRM_STATE = "REMOVE_DATATABLE_CONFIRM_STATE";
export const REFRESH_DATATABLE_UPDATED_AT = "REFRESH_DATATABLE_UPDATED_AT";
export const DATATABLE_CONFIRM_ON_CHANGE = "DATATABLE_CONFIRM_ON_CHANGE";
export const SET_DATATABLE_CURRENT_PAGE = "SET_DATATABLE_CURRENT_PAGE";

// File Tab
export const REMOVE_FOLDER_TREE = "REMOVE_FOLDER_TREE";
export const GET_FOLDER_TREE = "GET_FOLDER_TREE";
export const SET_FILE_CONTEXT_MENU = "SET_FILE_CONTEXT_MENU";
export const REMOVE_FILE_CONTEXT_MENU = "REMOVE_FILE_CONTEXT_MENU";
export const SET_SHARE_FILE = "SET_SHARE_FILE";
export const REMOVE_SHARE_FILE = "REMOVE_SHARE_FILE";
export const SET_FILE_PATH = "SET_FILE_PATH";
export const REMOVE_FILE_PATH = "REMOVE_FILE_PATH";
export const SET_JSTREE_STATUS = "SET_JSTREE_STATUS";
export const REMOVE_JSTREE_STATUS = "REMOVE_JSTREE_STATUS";
export const SET_FOLDER_TREE_LOADING = "SET_FOLDER_TREE_LOADING";
export const REMOVE_FOLDER_TREE_LOADING = "REMOVE_FOLDER_TREE_LOADING";
export const UPDATE_FILE_STATUS = "UPDATE_FILE_STATUS";
export const REMOVE_FILE_STATUS_TRACKING = "REMOVE_FILE_STATUS_TRACKING";

// Photo Tab
export const UPLOAD_ASSET_IMAGE = "UPLOAD_ASSET_IMAGE";
export const GET_ASSET_IMAGES = "GET_ASSET_IMAGES";
export const REMOVE_ASSET_IMAGES = "REMOVE_ASSET_IMAGES";

// Vendor Bill Approve types
export const VENDOR_BILL_APPROVE_SET_COMMENT =
    "VENDOR_BILL_APPROVED_SET_COMMENT";
export const VENDOR_BILL_APPROVE_SET_ID = 'VENDOR_BILL_APPROVE_SET_ID';
export const VENDOR_BILL_APPROVE_UNSET_ID = 'VENDOR_BILL_APPROVE_UNSET_ID';
export const VENDOR_BILL_APPROVE_CLEAR_IDS = 'VENDOR_BILL_APPROVE_CLEAR_IDS';
export const VENDOR_BILL_APPROVE_TOGGLE_SELECT_ALL = 'VENDOR_BILL_APPROVE_TOGGLE_SELECT_ALL';

export const SET_VENDOR_BILL_APPROVE_CHART_LOADING =
    "SET_VENDOR_BILL_APPROVE_CHART_LOADING";
export const SET_VENDOR_BILL_DROPDOWN = "SET_VENDOR_BILL_DROPDOWN";
export const REMOVE_VENDOR_BILL_DROPDOWN = "SET_VENDOR_BILL_DROPDOWN";
// Vendor Bills types
export const SET_VENDOR_BILL_LOADING = "SET_VENDOR_BILL_LOADING";
export const REMOVE_VENDOR_BILL_LOADING = "REMOVE_VENDOR_BILL_LOADING";
export const GET_VENDOR_BILLS = "GET_VENDOR_BILLS";
export const GET_VENDOR_BILL_FAILED = "GET_VENDOR_BILL_FAILED";
export const GET_VENDOR_BILL_CHART = "GET_VENDOR_BILL_CHART";
export const SET_VENDOR_BILL_CHART_LOADING = "SET_VENDOR_BILL_CHART_LOADING";
export const SET_VENDOR_BILL_FIELD = "SET_VENDOR_BILL_FIELD";
export const CASECADE_STATUS_CODE = "CASECADE_STATUS_CODE";
export const SET_ACCOUNTING_MATIX = "SET_ACCOUNTING_MATIX";
export const SET_VENDOR_BILL_CLIN_DROPDOWN = "SET_VENDOR_BILL_CLIN_DROPDOWN";
export const SET_ACCOUNTING_MATIX_REF = "SET_ACCOUNTING_MATIX_REF";
export const SET_ACCOUNTING_MATIX_ASSOCIATIONS =
    "SET_ACCOUNTING_MATIX_ASSOCIATIONS";
export const SET_VENDOR_BILL_INVALID_SELECTION =
    "SET_VENDOR_BILL_INVALID_SELECTION";

// Properties types
export const SET_PROPERTY_LOADING = "SET_PROPERTY_LOADING";
export const REMOVE_PROPERTY_LOADING = "REMOVE_PROPERTY_LOADING";
export const GET_PROPERTIES = "GET_PROPERTIES";
export const PROPERTY_UPDATED = "PROPERTY_UPDATED";
export const GET_PROPERTY = "GET_PROPERTY";
export const CLEAR_PROPERTY_FIELDS = "CLEAR_PROPERTY_FIELDS";
export const SET_PROPERTY_UTILITY_VENDORS = "SET_PROPERTY_UTILITY_VENDORS";
export const SET_PROPERTY_FIELDS = "SET_PROPERTY_FIELDS";
export const SET_PROPERTY_OLD_VALUE = "SET_PROPERTY_OLD_VALUE";
export const REMOVE_PROPERTY_OLD_VALUE = "REMOVE_PROPERTY_OLD_VALUE";
export const GET_PROPERTY_FAILED = "GET_PROPERTY_FAILED";
export const GET_PROPERTY_CHART = "GET_PROPERTY_CHART";
export const SET_PROPERTY_CHART_LOADING = "SET_PROPERTY_CHART_LOADING";
export const UPDATE_PROPERTY_SIX_PART_FILE = "UPDATE_PROPERTY_SIX_PART_FILE";
export const SET_PROPERTY_ACCESS = "SET_PROPERTY_ACCESS";

// Property-----Budget
export const GET_BUDGET_FEE_SCHEDULE = "GET_BUDGET_FEE_SCHEDULE";
export const SET_BUDGET_DATA = "SET_BUDGET_DATA";
export const GET_BUDGET_FEE_SCHEDULE_FAILED = "GET_BUDGET_FEE_SCHEDULE_FAILED";
export const SET_LOADING_BUDGET = "SET_LOADING_BUDGET";
export const REMOVE_LOADING_BUDGET = "REMOVE_LOADING_BUDGET";

// Property-----Disposition
export const SET_DISPOSITION_PURCHASERS = "SET_DISPOSITION_PURCHASERS";
export const SET_DISPOSITION_COMMISSION = "SET_DISPOSITION_COMMISSION";
export const UPDATE_DISPOSITION_COMMISSION = "UPDATE_DISPOSITION_COMMISSION";
export const GET_DISPOSITION_FEE_SCHEDULE = "GET_DISPOSITION_FEE_SCHEDULE";

// Property-----Liens types
export const SET_FINANCIAL_LIENS = "SET_FINANCIAL_LIENS";
export const UPDATE_FINANCIAL_LIENS = "UPDATE_FINANCIAL_LIENS";
export const FINANCIAL_LIEN_FAILED = "FINANCIAL_LIEN_FAILED";

// Property-----Management
export const SET_PROPM_LOCKBOX_INFO = "SET_PROPM_LOCKBOX_INFO";
export const SET_PROPM_INSPECTION = "SET_PROPM_INSPECTION";
export const SET_PROPM_MAINTENACE_REPAIR = "SET_PROPM_MAINTENACE_REPAIR";
export const SET_PROPM_VIOLATIONS = "SET_PROPM_VIOLATIONS";
export const SET_PROPM_UTILITY_VENDOR_REFERENCE = "SET_PROPM_UTILITY_VENDOR_REFERENCE";

// Property-----Marketing
export const SET_MARKETING_HAS_BROCHURE = "SET_MARKETING_HAS_BROCHURE";

// Property-----Amenities
export const SET_AMENITIES = "SET_AMENITIES";
export const UPDATE_AMENITIES = "UPDATE_AMENITIES";
export const AMENITY_FAILED = "AMENITY_FAILED";

// Property-----Contacts
export const SET_PROPERTY_CONTACTS = "SET_PROPERTY_CONTACTS";
export const UPDATE_PROPERTY_CONTACTS = "UPDATE_PROPERTY_CONTACTS";
export const PROPERTY_CONTACT_FAILED = "PROPERTY_CONTACT_FAILED";

// Property-----Title
export const SET_PROPERTY_TITLE_NOTES = "SET_PROPERTY_TITLE_NOTES";
export const REMOVE_PROPERTY_TITLE_NOTES = "REMOVE_PROPERTY_TITLE_NOTES";

// Property-----Files
export const SET_PROPERTY_FILE_CONTEXT_MENU = "SET_PROPERTY_FILE_CONTEXT_MENU";
export const SET_PROPERTY_FILE_PATH = "SET_PROPERTY_FILE_PATH";
export const SET_PROPERTY_SHARE_FILE = "SET_PROPERTY_SHARE_FILE";
export const SET_PROPERTY_JSTREE_STATUS = "SET_PROPERTY_JSTREE_STATUS";
export const REMOVE_PROPERTY_JSTREE_STATUS = "REMOVE_PROPERTY_JSTREE_STATUS";

// Property-----Notes

// Property-----Videos
export const SET_VIDEOS = "SET_VIDEOS";
export const SET_VIDEOS_LOADING = "SET_VIDEOS_LOADING";
export const REMOVE_VIDEOS_LOADING = "REMOVE_VIDEOS_LOADING";
export const SET_VIDEO_FIELDS = "SET_VIDEO_FIELDS";
export const SET_VIDEO_UPLOADING = "SET_VIDEO_UPLOADING";
export const REMOVE_VIDEO_UPLOADING = "REMOVE_VIDEO_UPLOADING";

export const SET_PRESEIZURE_PACKAGE_VIEW = "SET_PRESEIZURE_PACKAGE_VIEW";
export const SET_PRESEIZURE_PACKAGE_LOADING = "SET_PRESEIZURE_PACKAGE_LOADING";
export const SET_PRESEIZURE_PACKAGE_FIELD_LOADING = "SET_PRESEIZURE_PACKAGE_FIELDLOADING";
export const UPDATE_PRESEIZURE_PACKAGE_FIELD = "UPDATE_PRESEIZURE_PACKAGE_FIELD";
export const SET_PRESEIZURE_PACKAGE_BUDGET_DATA = "SET_PRESEIZURE_PACKAGE_BUDGET_DATA";
export const SET_PRESEIZURE_PACKAGE_DROPDOWNS = "SET_PRESEIZURE_PACKAGE_DROPDOWNS";

// Autombile
export const SET_AUTOMOBILE_LOADING = "SET_AUTOMOBILE_LOADING";
export const REMOVE_AUTOMOBILE_LOADING = "REMOVE_AUTOMOBILE_LOADING";
export const GET_AUTOMOBILES = "GET_AUTOMOBILES";
export const GET_AUTOMOBILE = "GET_AUTOMOBILE";
export const REMOVE_AUTOMOBILE = "REMOVE_AUTOMOBILE";
export const SET_AUTOMOBILE_DATA = "SET_AUTOMOBILE_DATA";
export const SET_AUTOMOBILE_VIN_LOADING = "SET_AUTOMOBILE_VIN_LOADING";
export const REMOVE_AUTOMOBILE_VIN_LOADING = "REMOVE_AUTOMOBILE_VIN_LOADING";
export const GET_AUTOMOBILE_VIN_INFORMATION = "GET_AUTOMOBILE_VIN_INFORMATION";
export const REMOVE_AUTOMOBILE_VIN_INFORMATION =
    "REMOVE_AUTOMOBILE_VIN_INFORMATION";
export const CLEAR_AUTOMOBILE_SEARCH_FIELDS = "CLEAR_AUTOMOBILE_SEARCH_FIELDS";
export const UPDATE_AUTOMOBILE_SEARCH_COLUMN =
    "UPDATE_AUTOMOBILE_SEARCH_COLUMN";
export const UPDATE_AUTOMOBILE_VIN_RESULTS = "UPDATE_AUTOMOBILE_VIN_RESULTS";
export const SET_AUTOMOBILE_DROPDOWN = "SET_AUTOMOBILE_DROPDOWN";
export const SET_AUTOMOBILE_CONTACTS = "SET_AUTOMOBILE_CONTACTS";
export const REMOVE_AUTOMOBILE_DROPDOWN = "REMOVE_AUTOMOBILE_DROPDOWN";

// AUTOMOBILE - SET & REMOVE OLD VALUE
export const SET_AUTOMOBILE_OLD_VALUE = "SET_AUTOMOBILE_OLD_VALUE";
export const REMOVE_AUTOMOBILE_OLD_VALUE = "REMOVE_AUTOMOBILE_OLD_VALUE";

// Automobile-----Condition
export const SET_CURRENT_AUTO_PART = "SET_CURRENT_AUTO_PART";
export const REMOVE_CURRENT_AUTO_PART = "REMOVE_CURRENT_AUTO_PART";

// Automobile------Photos
export const UPLOAD_AUTOMOBILE_IMAGE = "UPLOAD_AUTOMOBILE_IMAGE";
export const GET_AUTOMOBILE_IMAGES = "GET_AUTOMOBILE_IMAGES";
export const REMOVE_AUTOMOBILE_IMAGES = "REMOVE_AUTOMOBILE_IMAGES";

// Automobile-----Marketing
export const SET_AUTOMOBILE_MARKETING_HAS_BROCHURE =
    "SET_AUTOMOBILE_MARKETING_HAS_BROCHURE";
export const SET_AUTOMOBILE_MARKETING_PRICE_HISTORY =
    "SET_AUTOMOBILE_MARKETING_PRICE_HISTORY";
export const SET_AUTOMOBILE_MARKETING_OFFER_HISTORY =
    "SET_AUTOMOBILE_MARKETING_OFFER_HISTORY";

// Contacts
export const SET_CONTACT_LOADING = "SET_CONTACT_LOADING";
export const REMOVE_CONTACT_LOADING = "REMOVE_CONTACT_LOADING";
export const GET_LOGGED_IN_CONTACT = "GET_LOGGED_IN_CONTACT";
export const REMOVE_LOGGED_IN_CONTACT = "REMOVE_LOGGED_IN_CONTACT";
export const GET_CONTACTS = "GET_CONTACTS";
export const GET_CONTACT = "GET_CONTACT";
export const GET_ADD_CONTACT = "GET_ADD_CONTACT";
export const SET_CONTACT_DATA = "SET_CONTACT_DATA";
export const SET_ENABLE_LOGIN = "SET_ENABLE_LOGIN";
export const REMOVE_CONTACT = "REMOVE_CONTACT";
export const SET_CONTACT_SKELETON = "SET_CONTACT_SKELETON";
export const REMOVE_CONTACT_SKELETON = "REMOVE_CONTACT_SKELETON";

// NAME: contactstypes
export const SET_CONTACT_TYPE_LOADING = "SET_CONTACT_TYPE_LOADING";
export const REMOVE_CONTACT_TYPE_LOADING = "REMOVE_CONTACT_TYPE_LOADING";
export const GET_CONTACT_TYPE = "GET_CONTACT_TYPE";
export const GET_CONTACT_TYPE_CONTACTS = "GET_CONTACT_TYPE_CONTACTS";
export const REMOVE_CONTACT_TYPE = "REMOVE_CONTACT_TYPE";

// Orders Types
export const GET_ORDER_CHART = "GET_ORDER_CHART";

// Order Line Item GET_ORDER_LINE_CHART
export const GET_ORDER_LINE_CHART = "GET_ORDER_LINE_CHART";
export const SET_CLIN_COMMENTS = "SET_CLIN_COMMENTS";

// Logs types
export const GET_LOG_CHART = "GET_LOG_CHART";

// Account
export const GET_ACCOUNT = "GET_ACCOUNT";
export const SET_ACCOUNT_LOADING = "SET_ACCOUNT_LOADING";
export const REMOVE_ACCOUNT_LOADING = "REMOVE_ACCOUNT_LOADING";
export const SET_ACCOUNT_DATA = "SET_ACCOUNT_DATA";

// Amenity Types
export const SET_AMENITY_LOADING = "SET_AMENITY_LOADING";
export const REMOVE_AMENITY_LOADING = "REMOVE_AMENITY_LOADING";
export const GET_AMENITY = "GET_AMENITY";
export const SET_AMENITY_FIELDS = "SET_AMENITY_FIELDS";

// NAME: Roles
export const SET_ROLE_LOADING = "SET_ROLE_LOADING";
export const REMOVE_ROLE_LOADING = "REMOVE_ROLE_LOADING";
export const GET_ROLE = "GET_ROLE";
export const SET_ROLE_FIELDS = "SET_ROLE_FIELDS";
export const SET_ROLE_SKELETON = "SET_ROLE_SKELETON";

// NAME: Groups
export const SET_GROUP_LOADING = "SET_GROUP_LOADING";
export const REMOVE_GROUP_LOADING = "REMOVE_GROUP_LOADING";
export const GET_GROUP = "GET_GROUP";
export const SET_GROUP_SKELETON = "SET_GROUP_SKELETON";
export const SET_GROUP_DROPDOWN = "SET_GROUP_DROPDOWN";
export const SET_GROUP_MODULE_NAME = "SET_GROUP_MODULE_NAME";

// Vendors
export const SET_VENDORS_LOADING = "SET_VENDORS_LOADING";
export const REMOVE_VENDORS_LOADING = "REMOVE_VENDORS_LOADING";
export const GET_VENDOR = "GET_VENDOR";
export const SET_VENDOR_FIELD = "SET_VENDOR_FIELD";

// NAME: reports
export const SET_REPORT_LOADING = "SET_REPORT_LOADING";
export const REMOVE_REPORT_LOADING = "REMOVE_REPORT_LOADING";
export const GET_REPORT = "GET_REPORT";
export const GET_OVERLAY = "GET_OVERLAY";
export const SET_REPORT_SKELETON = "SET_REPORT_SKELETON";

// Order Line Items
export const SET_ORDER_LINE_LOADING = "SET_ORDER_LINE_LOADING";
export const REMOVE_ORDER_LINE_LOADING = "REMOVE_ORDER_LINE_LOADING";
export const GET_ORDER_LINE = "GET_ORDER_LINE";
export const SET_ORDER_LINE_DROPDOWN = "SET_ORDER_LINE_DROPDOWN";
export const REMOVE_ORDER_LINE_DROPDOWN = "REMOVE_ORDER_LINE_DROPDOWN";
export const SET_ORDER_LINE_FIELDS = "SET_ORDER_LINE_FIELDS";
export const SET_ORDER_LINE_SKELETON = "SET_ORDER_LINE_SKELETON";

//  NAME: Orders
export const SET_ORDER_LOADING = "SET_ORDER_LOADING";
export const SET_ORDER_DROPDOWNS = "SET_ORDER_DROPDOWNS";
export const SET_ORDER_DATA = "SET_ORDER_DATA";
export const SET_ORDER_EXISTING_CLINS = "SET_ORDER_EXISTING_CLINS";
export const SET_ORDER_LINE_ITEMS = "SET_ORDER_LINE_ITEMS";
// export const SET_ORDER_LINE_FIELDS = "SET_ORDER_LINE_FIELDS";
export const SET_REQUIRES_REASON_FOR_CHANGE = "SET_REQUIRES_REASON_FOR_CHANGE";

//  NAME: videos types
export const GET_VIDEOS = "GET_VIDEOS";
export const GET_VIDEO_FIELDS = "GET_VIDEO_FIELDS";
export const SET_VIDEO_LOADING = "SET_VIDEO_LOADING";
export const REMOVE_VIDEO_LOADING = "REMOVE_VIDEO_LOADING";

// NAME: Account Codes
export const SET_ACCOUNT_CODE_LOADING = "SET_ACCOUNT_CODE_LOADING";
export const SET_ACCOUNT_CODE_DATA = "SET_ACCOUNT_CODE_DATA";
export const SET_ALL_CONTRACTS_LOADING = "SET_ALL_CONTRACTS_LOADING";
export const SET_SELECTED_CONTRACT_PERIODS_LOADING =
    "SET_SELECTED_CONTRACT_PERIODS_LOADING";
export const SET_CLIN_MATRIX_LOADING = "SET_CLIN_MATRIX_LOADING";
export const SET_CLIN_MATRIX = "SET_CLIN_MATRIX";
export const SET_SELECTED_CONTRACT_ID = "SET_SELECTED_CONTRACT_ID";
export const SET_SELECTED_PERIOD_ID = "SET_SELECTED_PERIOD_ID";
export const SET_CONTRACTS = "SET_CONTRACTS";
export const SET_PERIODS = "SET_PERIODS";
export const SET_CLIN_ASSOCIATIONS = "SET_CLIN_ASSOCIATIONS";

// My Dropzone
export const SET_UPLOADING_STATE = "SET_UPLOADING_STATE";

// Tangibles
export const UPDATE_TANGIBLE_FIELD = "UPDATE_TANGIBLE_FIELD";
export const SET_TANGIBLE_VIEW = "SET_TANGIBLE_VIEW";
export const SET_TANGIBLE_CONTRACT = "SET_TANGIBLE_CONTRACT";
export const SET_TANGIBLE_SUB_TYPE = "SET_TANGIBLE_SUB_TYPE";
export const SET_TANGIBLE_SECONDARY_TYPE = "SET_TANGIBLE_SECONDARY_TYPE";
export const SET_TANGIBLE_TERTIARY_TYPE = "SET_TANGIBLE_TERTIARY_TYPE";
export const SET_TANGIBLE_TASK_ORDER = "SET_TANGIBLE_TASK_ORDER";
export const SET_TANGIBLE_ACCOUNTING = "SET_TANGIBLE_ACCOUNTING";

// Intangibles
export const SET_INTANGIBLE_VIEW = "SET_INTANGIBLE_VIEW";
export const UPDATE_INTANGIBLE_FIELD = "UPDATE_INTANGIBLE_FIELD";
export const SET_INTANGIBLE_CONTRACTS = "SET_INTANGIBLE_CONTRACTS";

// Leases
export const SET_LEASE_LOADING = "SET_LEASE_LOADING";
export const SET_LEASE_VIEW = "SET_LEASE_VIEW";
export const UPDATE_LEASE_FIELD = "UPDATE_LEASE_FIELD";
export const SET_LEASE_ADDRESS_VALIDATION = "SET_ADDRESS_VALIDATION";

// Bookmark
export const GET_BOOKMARK = "GET_BOOKMARK";

// Asset Associations
export const SET_ASSET_ASSOCIATIONS = "SET_ASSET_ASSOCIATIONS";
export const SET_ASSET_ASSOCIATIONS_METADATA = "SET_ASSET_ASSOCIATIONS_METADATA";
export const SET_ASSET_ASSOCIATIONS_RECORD = "SET_ASSET_ASSOCIATIONS_RECORD";
export const SET_ASSET_ASSOCIATIONS_LOADING = "SET_ASSET_ASSOCIATIONS_LOADING";

//  Generic Modal
export const SET_REDUX_CONFIRM_MODAL_DATA = "SET_REDUX_CONFIRM_MODAL_DATA";
export const SET_REDUX_CONFIRM_MODAL_SHOW = "SET_REDUX_CONFIRM_MODAL_SHOW";

//  NAME: Title Dashboard scope toggle
export const SET_TITLE_SCOPE = "SET_TITLE_SCOPE";

//  NAME: Customer Service Dashboard scope filters
export const SET_CUSTOMER_SERVICE_SCOPE = "SET_CUSTOMER_SERVICE_SCOPE";

// Trust Center
export const SET_TRUST_CENTER_LOADING = "TRUST_CENTER_LOADING";
export const REMOVE_TRUST_CENTER_LOADING = "TRUST_CENTER_LOADING";
